<template>
  <v-container
    v-if="canShowOrderType"
    fluid
  >
    <v-row dense>
      <v-col cols="12">
        <v-btn-toggle
          v-model="orderTypeModel"
          :dense="dense"
          :disabled="orderTypeLoading"
          borderless
          class="elevation-0 pa-0 ma-0"
          mandatory
          style="width: 100%;"
          @change="onSelectorChange"
        >
          <template v-for="orderType in AppOrderTypes">
            <v-btn
              :key="orderType.Id"
              :class="[orderType.Color, {'flex-grow-1': orderTypeModel === orderType.Id}]"
              :disabled="orderTypeLoading || (orderType.Id === OrderTypeEnum.COLLECTION && !AppConfig.Marketplace.SupportsCollection) || (orderType.Id === OrderTypeEnum.DELIVERY && !AppConfig.Marketplace.SupportsDelivery)"
              :style="orderTypeModel === orderType.Id ? 'opacity: 1' : 'opacity: 0.35'"
              :value="orderType.Id"
              class="elevation-0 white--text pa-2"
              min-width="48"
            >
              <span
                v-if="!showSelectedNameOnly || (showSelectedNameOnly && orderTypeModel === orderType.Id)"
                class="mr-2 brand-text-title"
              >
                {{ orderType.Name }}
              </span>

              <v-icon
                v-if="orderType.Icon"
                color="white"
              >
                {{ orderType.Icon }}
              </v-icon>
            </v-btn>
          </template>
        </v-btn-toggle>
      </v-col>

      <v-col
        v-if="cartDeliveryService"
        cols="12"
      >
        <v-alert
          border="left"
          class="mb-0 pr-2 text-no-select"
          colored-border
          dense
          text
          type="info"
        >
          {{ getTranslatedField(deliveryServiceCharge) }}

          <template #prepend>
            <v-icon
              class="mr-2"
              color="info"
              size="28"
            >
              mdi-moped
            </v-icon>
          </template>

          <template #append>
            {{ cartDeliveryService.amount | currency }}
          </template>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import OrderTypeSelectorMixin from '@/theme/default/components/cart/OrderTypeSelector.js'

export default {
  name  : 'OrderTypeSelector',
  mixins: [OrderTypeSelectorMixin]
}
</script>

<style scoped src="@/theme/default/components/cart/OrderTypeSelector.css"></style>

<style scoped>
</style>
